import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

interface Props {
  align?: 'left' | 'right'
  status?: boolean
  color?: string
}

export const MainWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
`

export const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`

export const Divider = styled.div<Props>`
  height: 1px;
  width: calc(100% - 40px);
  background-color: ${({ status, theme }) =>
    status ? theme.color.brandGreen : theme.color.mediumGrey};
`

export const Circle = styled.div<Props>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border-radius: 20px;
  border: 1px solid
    ${({ status, theme }) =>
      status ? theme.color.brandGreen : theme.color.lightGrey};
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ status, theme }) =>
    status ? theme.color.brandGreen : theme.color.darkGrey};
  font-weight: ${variables.fontWeight600};
  font-size: ${variables.fontSize18};
  line-height: 27px;
`

export const Text = styled.div<Props>`
  color: ${(props: Props) => props.color};
  text-align: ${(props: Props) => props.align};
`
